import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "@/components/ui/modal";
import Button from "@/components/ui/button";
import "./index.scss";

/** Tarayıcıda iframe ile önizlenebilen uzantılar (xlsx, csv, doc vb. indirilir, önizlenmez) */
const PREVIEWABLE_EXTENSIONS = ["pdf", "png", "jpg", "jpeg", "gif", "webp", "svg", "bmp"];

function getExtension(fileName: string): string {
  const lastDot = fileName.lastIndexOf(".");
  if (lastDot === -1) return "";
  return fileName.slice(lastDot + 1).toLowerCase();
}

function isPreviewable(fileName: string): boolean {
  const ext = getExtension(fileName);
  return PREVIEWABLE_EXTENSIONS.includes(ext);
}

export interface DocumentViewerModalProps {
  isOpen: boolean;
  onClose: () => void;
  /** Presigned URL – iframe ile açılır veya İndir butonu ile kullanılır */
  downloadUrl: string | null;
  title?: string;
}

const DocumentViewerModal: React.FC<DocumentViewerModalProps> = ({
  isOpen,
  onClose,
  downloadUrl,
  title,
}) => {
  const { t } = useTranslation();
  const canPreview = title ? isPreviewable(title) : true;
  const showIframe = downloadUrl && canPreview;
  const showDownloadOnly = downloadUrl && !canPreview;

  const handleDownload = () => {
    if (downloadUrl) window.open(downloadUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title ?? t("library.document.viewerTitle")}
      size="xl"
      customFooter={null}
    >
      <div className="document-viewer-modal-content">
        {!downloadUrl ? (
          <p className="document-viewer-empty">{t("library.download.noUrl")}</p>
        ) : showIframe ? (
          <iframe
            src={downloadUrl}
            title={title ?? t("common.view")}
            className="document-viewer-iframe"
          />
        ) : showDownloadOnly ? (
          <div className="document-viewer-download-only">
            <p className="document-viewer-download-message">
              {t("library.document.noPreview")}
            </p>
            <Button variant="contained" color="primary" onClick={handleDownload}>
              {t("common.download")}
            </Button>
          </div>
        ) : null}
      </div>
    </Modal>
  );
};

export default DocumentViewerModal;
